<script setup lang="ts">
import { AttributeMenuBlock } from '@interfaces/menu.interface'
import BlockSection from './BlockSection.vue'
import { Link } from '@inertiajs/vue3'

defineProps<{
    block: AttributeMenuBlock,
}>()
</script>

<template>
    <BlockSection :title="block.title">
        <ul class="space-y-1.5">
            <li
                v-for="(item, itemIdx) in block.items"
                :key="itemIdx"
            >
                <Link
                    :href="item.url"
                    class="flex items-center transition-colors rounded-lg group"
                >
                <span class="truncate text-grayscale-800 group-hover:text-primary-800">{{ item.name }}</span>
                </Link>
            </li>
        </ul>
    </BlockSection>
</template>
